export const COOKIE_NOTICE_KEY = 'scene-share-cookie-notice';
export const COOKIE_NOTICE_VERSION = '2026-11-02.1';
export const OPTIONAL_CATEGORIES = ['external', 'analytics', 'marketing'];
// No optional provider is configured. Future integrations must be listed in the
// notice, gated before loading, and require a new version / fresh choice.
const ACTIVE_OPTIONAL_CATEGORIES = [];
export function readCookieChoices(now = Date.now()) {
  try {
    const value = JSON.parse(localStorage.getItem(COOKIE_NOTICE_KEY));
    if (value?.version === COOKIE_NOTICE_VERSION && value.expiresAt > now)
      return Object.fromEntries(OPTIONAL_CATEGORIES.map(key => [key, value.choices?.[key] === true]));
  } catch { /* Optional storage can be unavailable. */ }
  return Object.fromEntries(OPTIONAL_CATEGORIES.map(key => [key, false]));
}
export function isOptionalCategoryAllowed(category) {
  return ACTIVE_OPTIONAL_CATEGORIES.includes(category) && readCookieChoices()[category] === true;
}
export const OPEN_COOKIE_NOTICE = 'scene-share-open-cookie-notice';
export function hasAcknowledgedNotice(now = Date.now()) {
  try {
    const value = JSON.parse(localStorage.getItem(COOKIE_NOTICE_KEY));
    return value?.version === COOKIE_NOTICE_VERSION && Number.isFinite(value.expiresAt) && value.expiresAt > now;
  } catch { return false; }
}
export function acknowledgeNotice(now = Date.now(), choices = {}) {
  try { localStorage.setItem(COOKIE_NOTICE_KEY, JSON.stringify({ version: COOKIE_NOTICE_VERSION,
    acknowledgedAt: now, expiresAt: now + 180 * 86400000,
    choices: Object.fromEntries(OPTIONAL_CATEGORIES.map(key => [key, choices[key] === true])) })); } catch { /* Closing still works without storage. */ }
}
export function openCookieNotice() { window.dispatchEvent(new Event(OPEN_COOKIE_NOTICE)); }

// Only names, never values or authentication data. No information leaves the browser.
export async function inspectStorageNames() {
  const normalise = name => name.startsWith('firebase:') ? name.split(':').slice(0, 2).join(':') + ':*' : name.slice(0, 80);
  const names = storage => [...new Set(Array.from({ length: storage.length }, (_, index) => storage.key(index)).filter(Boolean).map(normalise))].sort();
  const result = {};
  try { result.cookies = document.cookie.split(';').map(item => item.trim().split('=')[0]).filter(Boolean).map(normalise); } catch { result.cookies = null; }
  try { result.local = names(window.localStorage); } catch { result.local = null; }
  try { result.session = names(window.sessionStorage); } catch { result.session = null; }
  try { result.databases = typeof window.indexedDB?.databases === 'function' ? (await window.indexedDB.databases()).map(db => db.name).filter(Boolean).sort() : null; } catch { result.databases = null; }
  return result;
}
